// Local
import { caseManagementEndpoints } from '@app/types/api/endpoints/case-management.endpoints';
import { FSXEndpoints } from '@app/types/api/endpoints/endpoints.model';
import { trialBinderEndpoints } from '@app/types/api/endpoints/trial-binder.endpoints';

export function fsxApi(baseURL: string): FSXEndpoints {
  const versionedUrl = `${baseURL}`;

  return {
    trialBinder: trialBinderEndpoints(versionedUrl),
    caseManagement: caseManagementEndpoints(versionedUrl)
  };
}
